import axios from 'axios';
import { baseUrl,baseUrl_SPB } from '../BaseUrl';

 const TimesheetPenaltyCalculationsService = async (token,rosterTimeAllocationId,staffId) => {

          
      try {
        const response = await axios.get(`${baseUrl_SPB}/api/v1/tpc/calcts?rosterTimeAllocationId=${rosterTimeAllocationId}&staffId=${staffId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log('penalty calculations by user id');
        if (response.status !== 200) {
          throw new Error('Failed to fetch timesheets by company');
        }

        const data = response.data;
        return data;
        
      } catch (error) {
        console.error('penalty calculations:', error);
      }
    }



    export default TimesheetPenaltyCalculationsService;